/**
 * @generated SignedSource<<f37a9642cbed3817c10cc2b46a1f9701>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FrequencyPeriod = "Day" | "Hour" | "Month" | "Week" | "Year";
export type ProductBalanceManagementType = "POSTPAID" | "PREPAID";
export type ProductType = "CHARACTERISTIC" | "DEAL" | "FEATURE" | "MARKETING" | "ORIGINAL_RRP";
export type ExistingPlansChangePlanOfferDetailsQuery$variables = {
  lineNumber: string;
  ifpOfferId?: string | null;
  deviceOfferId?: string | null;
  cartId?: string | null;
};
export type ExistingPlansChangePlanOfferDetailsQuery$data = {
  readonly me: {
    readonly line: {
      readonly planProductOffers: {
        readonly offerDetails: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null;
          readonly category: ReadonlyArray<{
            readonly id: string;
          }> | null;
          readonly contentKey: string | null;
          readonly contractTerm: {
            readonly name: string | null;
          } | null;
          readonly description: string | null;
          readonly price: {
            readonly basePrice: number | null;
            readonly basePriceExcludingTax: number | null;
            readonly effectivePrice: number | null;
            readonly effectivePriceExcludingTax: number | null;
            readonly frequency: {
              readonly period: FrequencyPeriod;
              readonly value: number;
            } | null;
            readonly priceType: string;
          } | null;
          readonly images: ReadonlyArray<{
            readonly thumbnailUrl: string | null;
          }> | null;
          readonly entitlements: ReadonlyArray<{
            readonly contentKey: string | null;
            readonly iconUrl: string | null;
            readonly longDescription: string | null;
            readonly name: string;
            readonly shortDescription: string | null;
            readonly sortOrder: number | null;
            readonly type: string | null;
          }> | null;
          readonly promotions: ReadonlyArray<{
            readonly contentKey: string | null;
            readonly iconUrl: string | null;
            readonly longDescription: string | null;
            readonly name: string;
            readonly productType: ProductType;
            readonly shortDescription: string | null;
            readonly sortOrder: number | null;
          }> | null;
          readonly productCharacteristics: {
            readonly balanceManagement: ProductBalanceManagementType | null;
            readonly isEligibilityRequired: boolean | null;
          } | null;
          readonly dataLayerCategory: string | null;
        }>;
      };
    };
  };
};
export type ExistingPlansChangePlanOfferDetailsQuery = {
  variables: ExistingPlansChangePlanOfferDetailsQuery$variables;
  response: ExistingPlansChangePlanOfferDetailsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cartId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deviceOfferId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ifpOfferId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lineNumber"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentKey",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "lineNumber",
            "variableName": "lineNumber"
          }
        ],
        "concreteType": "Line",
        "kind": "LinkedField",
        "name": "line",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "cartId",
                "variableName": "cartId"
              },
              {
                "kind": "Variable",
                "name": "deviceOfferId",
                "variableName": "deviceOfferId"
              },
              {
                "kind": "Variable",
                "name": "ifpOfferId",
                "variableName": "ifpOfferId"
              }
            ],
            "concreteType": "PlanProductOffers",
            "kind": "LinkedField",
            "name": "planProductOffers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BaseOfferDetail",
                "kind": "LinkedField",
                "name": "offerDetails",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfferDetailCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContractTerm",
                    "kind": "LinkedField",
                    "name": "contractTerm",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "basePrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "basePriceExcludingTax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "effectivePrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "effectivePriceExcludingTax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceFrequency",
                        "kind": "LinkedField",
                        "name": "frequency",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "period",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Entitlement",
                    "kind": "LinkedField",
                    "name": "entitlements",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "kind": "LinkedField",
                    "name": "promotions",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productType",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductCharacteristic",
                    "kind": "LinkedField",
                    "name": "productCharacteristics",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "balanceManagement",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isEligibilityRequired",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dataLayerCategory",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExistingPlansChangePlanOfferDetailsQuery",
    "selections": (v11/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExistingPlansChangePlanOfferDetailsQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "b3333c9d2a33d0f8724948e33428ea54",
    "id": null,
    "metadata": {},
    "name": "ExistingPlansChangePlanOfferDetailsQuery",
    "operationKind": "query",
    "text": "query ExistingPlansChangePlanOfferDetailsQuery(\n  $lineNumber: String!\n  $ifpOfferId: String\n  $deviceOfferId: String\n  $cartId: String\n) {\n  me {\n    line(lineNumber: $lineNumber) {\n      planProductOffers(ifpOfferId: $ifpOfferId, deviceOfferId: $deviceOfferId, cartId: $cartId) {\n        offerDetails {\n          id\n          name\n          category {\n            id\n          }\n          contentKey\n          contractTerm {\n            name\n          }\n          description\n          price {\n            basePrice\n            basePriceExcludingTax\n            effectivePrice\n            effectivePriceExcludingTax\n            frequency {\n              period\n              value\n            }\n            priceType\n          }\n          images {\n            thumbnailUrl\n          }\n          entitlements {\n            contentKey\n            iconUrl\n            longDescription\n            name\n            shortDescription\n            sortOrder\n            type\n          }\n          promotions {\n            contentKey\n            iconUrl\n            longDescription\n            name\n            productType\n            shortDescription\n            sortOrder\n          }\n          productCharacteristics {\n            balanceManagement\n            isEligibilityRequired\n          }\n          dataLayerCategory\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "047d91dad22e734cdbcf3eafded6ba7e";

export default node;
